var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "handover" }, [
    _c("div", { staticClass: "page-head-container hotb-detail-page-head" }, [
      _c("div", { staticClass: "page-head clearfix" }, [
        _c(
          "div",
          { staticClass: "page-head-info clearfix" },
          [
            _c("HKLHeader", {
              attrs: {
                "link-class-left-primary": "link-back-to-tenancy",
                "label-left-primary": _vm.hotbHeaderLeftPrimaryLabel,
                "label-left-secondary": _vm.hotbHeaderLeftSecondaryLabel,
                "label-right-leading": _vm.$t("listNavigation.previousRecord"),
                "label-right-trailing": _vm.$t("listNavigation.nextRecord"),
                "navigation-entries": _vm.hotbListNavigationEntriesForHeader,
                "nav-base-path-hotb": _vm.hotbNavBasePath,
                "nav-base-path-tenant-project": _vm.tenantProjectNavBasePath,
                "current-record-id": _vm.$route.params.id,
              },
              on: {
                "left-primary": function ($event) {
                  return _vm.navTo(_vm.tenancyId)
                },
                "left-secondary": _vm.navToAllTenantProjects,
                "right-leading": _vm.onHklListNavEntry,
                "right-trailing": _vm.onHklListNavEntry,
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "row clearfix hotb-title-row" }, [
              _c(
                "div",
                {
                  staticClass: "title page-hotb-description",
                  attrs: { title: _vm.title },
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.title))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "options-wrapper" },
                    [
                      _c(
                        "PageHeaderOptions",
                        {
                          directives: [
                            { name: "hkldreset", rawName: "v-hkldreset" },
                          ],
                          staticClass: "options",
                          attrs: {
                            showSubstitute:
                              _vm.allowResetToDraft || _vm.allowComplete,
                            allowChangePIC: _vm.allowChangePIC,
                            allowCancel: _vm.allowCancel,
                            previousPersonInCharge: _vm.currentPersonInCharge,
                            confirmCancelMsg: _vm.$t("hint.cancelHandover"),
                            getSelectedList: _vm.getSelectedList,
                          },
                          on: {
                            "change-pic": function (val) {
                              return _vm.changePIC(val)
                            },
                            cancelItem: function ($event) {
                              return _vm.cancelHandover()
                            },
                          },
                        },
                        [
                          _c(
                            "li",
                            {
                              attrs: { slot: "substitute" },
                              slot: "substitute",
                            },
                            [
                              _vm.allowResetToDraft
                                ? _c(
                                    "DialogSlot",
                                    {
                                      ref: "resetToDraft",
                                      attrs: {
                                        id: "hotb-reset-to-draft-dialog",
                                        modalBtnClass: "btn--transparent",
                                        modalBtn: _vm.$t("action.resetToDraft"),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "font-bold",
                                          attrs: { slot: "content" },
                                          slot: "content",
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("hint.resetHotbToDraft")
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "buttons" },
                                          slot: "buttons",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              directives: [
                                                {
                                                  name: "hkldreset",
                                                  rawName: "v-hkldreset",
                                                },
                                              ],
                                              staticClass:
                                                "btn btn--orange close-reveal-modal",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.resetHotbToDraft()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("action.yesContinue")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.allowComplete
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn--transparent",
                                      on: {
                                        click: function ($event) {
                                          return _vm.initCompleteHotbModel()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t("action.notifyComplete")
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "handover-takeback-content" },
      [
        _c(
          "TabsContainer",
          {
            class: _vm.isTenant ? "tenant-view-tab-width" : "",
            attrs: {
              tabNames: _vm.isTenant ? _vm.tenantTabNames : _vm.tabNames,
              extendStyleA: _vm.extendStyleA,
            },
          },
          [
            _c("HandoverTakebackInformation", {
              attrs: {
                slot: _vm.tabsContainerIdMap.HOTBINFO,
                tabsContainerIdMap: _vm.tabsContainerIdMap,
                allowEdit: _vm.allowEditInfo,
                allowApprove: _vm.allowApprove,
                isWappr: _vm.isWappr,
                isSpecial: _vm.isSpecial,
                allowInvite: _vm.allowArrange,
                allowEditDocs: _vm.allowEditDocs,
              },
              slot: _vm.tabsContainerIdMap.HOTBINFO,
            }),
            _vm._v(" "),
            !_vm.isTenant
              ? _c("HandoverTakebackSchedule", {
                  ref: "hotbSchedule",
                  attrs: {
                    slot: _vm.tabsContainerIdMap.HOTBSCHEDULE,
                    allowEdit: _vm.allowEditOthers,
                    allowGeneratePdf: _vm.allowGeneratePdf,
                  },
                  slot: _vm.tabsContainerIdMap.HOTBSCHEDULE,
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.isTenant
              ? _c("KeySchedule", {
                  attrs: {
                    slot: _vm.tabsContainerIdMap.HOTBKEYSCHEDULE,
                    allowEdit: _vm.allowEditOthers,
                    allowGeneratePdf: _vm.allowGeneratePdf,
                  },
                  slot: _vm.tabsContainerIdMap.HOTBKEYSCHEDULE,
                })
              : _vm._e(),
            _vm._v(" "),
            _c("AttachmentsForTenant", {
              ref: "attachmentsForTenant",
              attrs: {
                slot: _vm.tabsContainerIdMap.HOTBATTACHMENTTOTENANT,
                allowEdit: _vm.allowEditDocsToTenant,
                isWappr: _vm.isWappr,
              },
              slot: _vm.tabsContainerIdMap.HOTBATTACHMENTTOTENANT,
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "reveal hotb-complete-model",
        attrs: { id: _vm.hotbCompleteModelId },
      },
      [
        _c("div", { staticClass: "complete-title required-flag" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("action.notifyComplete")) + "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "hotb-complete-type-group" }, [
          _c("div", { staticClass: "radio" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.signedDocUploaded,
                  expression: "signedDocUploaded",
                },
              ],
              attrs: {
                id: _vm.signedRadioBtnId,
                type: "radio",
                name: "hotb-complete-type",
              },
              domProps: {
                value: true,
                checked: _vm._q(_vm.signedDocUploaded, true),
              },
              on: {
                change: function ($event) {
                  _vm.signedDocUploaded = true
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "emphasis", attrs: { for: _vm.signedRadioBtnId } },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("handover.complete.signedDocsUploaded")) +
                    "\n        "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "radio" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.signedDocUploaded,
                  expression: "signedDocUploaded",
                },
              ],
              attrs: {
                id: _vm.unsignedRadioBtnId,
                type: "radio",
                name: "hotb-complete-type",
              },
              domProps: {
                value: false,
                checked: _vm._q(_vm.signedDocUploaded, false),
              },
              on: {
                change: function ($event) {
                  _vm.signedDocUploaded = false
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "emphasis",
                attrs: { for: _vm.unsignedRadioBtnId },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("handover.complete.unsignedDocsUploaded")) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "complete-attachments",
            class: !_vm.completeDocUploaded ? "error-highlight" : "",
          },
          [
            _c(
              "div",
              { staticClass: "complete-attachments-label required-flag" },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("handover.completeAttachments")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            true
              ? _c("HkldDropzone", {
                  ref: "hotbCompleteDropZone",
                  attrs: {
                    sourceId:
                      _vm.deep(_vm.currentHotb, "pubDocResourceId") || "",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("EditAttachments", {
              ref: "hotbCompleteAttachments",
              staticClass: "complete-edit-attachments",
              attrs: {
                sourceId: _vm.deep(_vm.currentHotb, "pubDocResourceId") || "",
                canEdit: false,
                isShowDes: false,
                canDelete: true,
                isShowUploadedDate: false,
                canDownloadAll: false,
                hiddenAttachments: _vm.hiddenAttachments,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "complete-date-label required-flag" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.isHandover
                  ? _vm.$t("handover.actualHandoverDate")
                  : _vm.$t("handover.actualTakebackDate")
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("DatePicker", {
          attrs: {
            format: "DD MMM YYYY",
            clearButton: false,
            calendarButton: true,
            calendarButtonIcon: "fa fa-calendar",
            value: _vm.completedDate,
          },
          on: {
            selected: function (val) {
              return _vm.updateCompleteDate(val)
            },
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "complete-btn-group" }, [
          _c(
            "button",
            {
              staticClass: "btn--darkblue",
              on: {
                click: function ($event) {
                  return _vm.cancelCompleteHotb()
                },
              },
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("action.cancel")) + "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn--orange",
              on: {
                click: function ($event) {
                  return _vm.complete()
                },
              },
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("action.confirm")) + "\n      "
              ),
            ]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }